(function(angular) {
    'use strict';

angular.module('bmrcReportGenerateComponent', ['bento.modern', 'bm.reporting.components.templates', 'bmrcReportGenerateService', 'pascalprecht.translate', 'bmpUserSettings', 'bmPermission', 'bluemoon.dms.modal.folder-selection', 'bluemoon.components.Notifications'])
    .directive('bmrcReportGenerateComponent', function() {
        return {
            restrict: 'E',
            scope: {
                'createReports': '&onCreate',
                'cancelCreateReports': '&onCancel',
                'fileTypes': '=?fileTypes',
                'reportDefinition': '<reportDefinition'
            },
            templateUrl: 'src/reporting/generate/report-generate-component.html',
            bindings: {
                reportDefinition: '<'
            },
            controllerAs: 'vm',
            controller: ['$scope', '$q', '$translate', 'bmPermission', 'bmrcReportGenerateService', 'bmpUserSettings', 'dmsFolderSelectionModalService', 'bluemoon.components.Notifications',
                function ($scope, $q, $translate, bmPermission, bmrcReportGenerateService, bmpUserSettings, dmsFolderSelectionModalService, notifications) {
                    var userSettingsKey = 'report-generate-component-data';
                    var isDefaultTypeIsExcel = false;
                    $scope.readOnly = false;
                    if ($scope.reportDefinition !== undefined && $scope.reportDefinition.filter(f => f.systemId === 'CLIENTDIRECTORYWITHCUSTOMFIELDS').length > 0){
                        isDefaultTypeIsExcel = true;
                        $scope.readOnly = true;
                    }
                    // Defaults
                    $scope.data = {
                        type: isDefaultTypeIsExcel ? 'EXCEL' : 'PDF',
                        createInDestinationDownloadToComputer: true,
                        sendToOnvioDocuments: false,
                        sendToBinderDocuments: false
                    };
                    $scope.definition = bmrcReportGenerateService.getDefinition();
                    bmpUserSettings.loadSettings().then(function() { // TODO - ng161 - handle reject
                        var settings = bmpUserSettings.get(userSettingsKey);
                        if (settings) {
                            var newData = JSON.parse(settings);
                            // Merge the saved data in. If we have added field that aren't in newData yet, those new fields will be defaulted properly.
                            for (var field in newData) {
                                if ((field === 'type' && !isDefaultTypeIsExcel) || (field !== 'type')){
                                    $scope.data[field] = newData[field];
                                }
                            }
                        }

                        $scope.showSendToBinder = $scope.definition.sendToBinderDocumentsVisible;
                        bmPermission.isGranted('OnvioDrive.MyDocuments').then(function (documentsGranted) {
                            $scope.showDocuments = documentsGranted && $scope.definition.sendToOnvioDocumentsVisible;

                            if (!$scope.showDocuments) {
                                $scope.data.sendToOnvioDocuments = false;
                            }

                            if (!$scope.showSendToBinder) {
                                $scope.data.sendToBinderDocuments = false;
                            }

                            //set download as enabled if is the only option available.
                            if (!$scope.data.sendToBinderDocuments && !$scope.data.sendToOnvioDocuments) {
                                $scope.data.createInDestinationDownloadToComputer = true;
                            }
                        });
                    });
                    $scope.selectedFolder = {};

                    if($scope.definition.useSelectFolder) {
                        var getSelectedFolder = bmrcReportGenerateService.getGetSelectedFolder();
                        getSelectedFolder().then(function(result) {
                            $scope.selectedFolder = {
                                id: result.documentFolderId,
                                name: result.documentFolderName,
                                type: result.documentFolderType,
                                clientId: result.client.id
                            };
                        });
                    }

                    $scope.createReports = function () {

                        if($scope.definition.sendToOnvioDocumentsVisible &&
                            $scope.definition.useSelectFolder &&
                            $scope.selectedFolder.id === undefined) {
                            notifications.setError('There Were Errors While Processing. Folder has not yet being set up. Please indicate folder first and retry one more time');

                            return;
                        }

                        var options = {
                            bundleMultiple: $scope.data.bundleMultipleReports,
                            downloadToComputer: $scope.data.createInDestinationDownloadToComputer,
                            fileTypeToGenerate: $scope.data.type,
                            sendToOnvio: $scope.data.sendToOnvioDocuments,
                            documentFolderId: $scope.selectedFolder.id,
                            sendToBinderDocuments: $scope.data.sendToBinderDocuments
                        };

                        var acceptFunc = bmrcReportGenerateService.getAcceptFunc();
                        acceptFunc(options);
                        bmpUserSettings.set(userSettingsKey, JSON.stringify($scope.data));
                    };

                    $scope.cancelCreateReports = function() {
                        var cancelFunc = bmrcReportGenerateService.getCancelFunc();
                        cancelFunc();
                    };

                    $scope.changeDownloadDestination = function() {
                        if ($scope.definition.sendToBinderDocumentsVisible) {
                            if (!$scope.data.createInDestinationDownloadToComputer) {
                                $scope.data.sendToBinderDocuments = true;
                            }
                        }
                    };

                    $scope.changeSendToBinderDestination = function() {
                        if ($scope.definition.sendToBinderDocumentsVisible) {
                            if (!$scope.data.sendToBinderDocuments) {
                                $scope.data.createInDestinationDownloadToComputer = true;
                            }
                        }
                    };

                    $scope.changeFolder = function() {
                        if(!$scope.definition.useSelectFolder) {
                            return;
                        }

                        dmsFolderSelectionModalService.open({
                            disabledItems: [{ id: $scope.selectedFolder.id, itemType: $scope.selectedFolder.type }],
                            rootContainer: {
                                id: $scope.selectedFolder.clientId,
                                itemType: $scope.selectedFolder.clientId ? 'Client' : 'ClientRoot'
                            },
                            titleText: $translate.instant('Bluemoon.Core.Setup.Project.SelectDMSFolder.Title'),
                            selectButtonText: $translate.instant('Bluemoon.Core.Setup.Project.SelectDMSFolder.Select'),
                            cancelButtonText: $translate.instant('Bluemoon.Core.Setup.Project.SelectDMSFolder.Cancel'),
                            newFolderText: $translate.instant('Bluemoon.Core.Setup.Project.SelectDMSFolder.Create'),
                            validate: function () {
                                // Check if the folder is allowed to be selected
                                return $q.when({ errorText: '', alerts: [] });
                            }
                        }).result.then(function(selectedFolder) {
                            $scope.selectedFolder = {
                                id: selectedFolder.id,
                                name: selectedFolder.name,
                                type: selectedFolder.itemType,
                                clientId: selectedFolder.primaryAssociationId
                            };
                        });
                    };
                }],
            link: function(scope, element) {
                element.ready(function() {
                    let combobox = element[0].querySelector('[role="combobox"]');
                    if (combobox) {
                        combobox.setAttribute('aria-labelledby', 'fileTypeTitle');
                    }
                });
            }
        };
    });
})(window.angular);
